<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="直播名称" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="直播描述" prop="intro">
            <el-input v-model="ruleForm.intro" type="textarea" maxlength="40" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="0">
        <el-col :span="12">
          <el-form-item label="封面上传" prop="cover">
            <imgUpload v-model="ruleForm.cover"> </imgUpload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详情封面" prop="banner">
            <!-- <imgUploads
                            component-id="'img"
                            :img-list="ruleForm.banner"
                            :limit="8"
                            @fileList="ruleForm.banner=$event"
                        ></imgUploads> -->
            <imgUpload v-model="ruleForm.banner"></imgUpload>
          </el-form-item>
        </el-col>
      </el-form-item>

      <el-form-item label="直播类别" prop="cate_uuid">
        <!-- <el-tag>+</el-tag> -->
        <el-select v-model="ruleForm.cate_uuid" multiple>
          <el-option v-for="item in typeList" :label="item.title" :value="item.uuid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="授课老师" prop="teacher_uuid">
        <el-select
          v-model="ruleForm.teacher_uuid"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="getTeacher"
          :loading="loading"
        >
          <el-option disabled="disabled" label="1" value="1">
            <div class="option">
              <span>老师昵称</span>
              <span>手机号</span>
            </div>
          </el-option>
          <el-option v-for="item in teacherList" :key="item.uuid" :label="item.name" :value="item.uuid">
            <div class="option">
              <span>{{ item.name }}</span>
              <span>{{ item.mobile }}</span>
            </div>
          </el-option>
        </el-select>
        <!-- <el-select v-model="ruleForm.teacher_uuid" multiple>
                    <el-option v-for="item in teacherList" :label="item.name" :value="item.uuid"></el-option>

                </el-select> -->
      </el-form-item>
      <el-row>
        <el-col :span="6">
          <el-form-item label="现价" prop="price">
            <el-input v-model="ruleForm.price">
              <span slot="prefix">￥</span>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <span style="color: #999; font-size: 12px; line-height: 40px">为0则为免费</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="原价" prop="original_price">
            <el-input v-model="ruleForm.original_price">
              <span slot="prefix">￥</span>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-form-item label="库存" prop="stock">
                <el-input-number v-model="ruleForm.stock" :min="0" :max="10000" label="库存"></el-input-number>

            </el-form-item> -->

      <el-form-item label="直播开始时间" prop="start_time">
        <!-- <el-date-picker v-model="ruleForm.dates" value-format="yyyy-MM-dd hh:mm:ss" type="datetimerange"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker> -->
        <el-date-picker
          v-model="ruleForm.start_time"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="直播简介" prop="detail">
        <fullEdit v-model="ruleForm.detail"></fullEdit>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import imgUploads from "@/components/pub/supperUpload.vue";
import fullEdit from "@/components/pub/fulledit.vue";
import { getLiveType, addLive, getLiveDetail, editLive } from "@/api/live.js";
import { getTeacherList } from "@/api/teacher.js";
export default {
  components: {
    imgUpload,
    imgUploads,
    fullEdit,
  },
  data() {
    return {
      dates: [],
      loading: false,
      typeList: [],
      teacherList: [],
      ruleForm: {
        cate_uuid: [],
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入直播名称",
            trigger: "blur",
          },
        ],
        intro: [
          {
            required: true,
            message: "请输入直播描述",
            trigger: "blur",
          },
        ],
        cover: [
          {
            required: true,
            message: "请上传直播封面",
            trigger: "change",
          },
        ],
        banner: [
          {
            required: true,
            message: "请上传详情封面",
            trigger: "change",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入现价",
            trigger: "blur",
          },
        ],
        start_time: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        original_price: [
          {
            required: true,
            message: "请输入原价",
            trigger: "blur",
          },
        ],
        cate_uuid: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个直播类别",
            trigger: "change",
          },
        ],
        teacher_uuid: [
          {
            required: true,
            message: "请选择授课老师",
            trigger: "change",
          },
        ],
        stock: [
          {
            required: true,
            message: "请填写库存",
            trigger: "change",
          },
        ],
        detail: [
          {
            required: true,
            message: "请填写简介",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    console.log();
    const row = this.$route.query;
    if (row.uuid) {
      this.getDetail(row);
    }
    this.getType();
    this.getTeacher("");
  },
  methods: {
    async getDetail(row) {
      const res = await getLiveDetail(row.uuid);

      if (res) {
        if (res.cate instanceof Array) {
          res.cate_uuid = res.cate.map((it) => {
            return it.uuid;
          });
        }
        // if (res.banner) {
        //     if (!Array.isArray(res.banner)) {
        //         res.banner = JSON.parse(res.banner)
        //     }
        // }
        this.ruleForm = {
          ...res,
          dates: [res.start_time, res.end_time],
        };
        console.log(res);
      }
    },
    getType() {
      getLiveType({ status: 2 }).then((res) => {
        console.log(res);
        if (res.data instanceof Array) {
          this.typeList = res.data;
        }
      });
    },
    getTeacher(keyword_search) {
      getTeacherList({
        keyword_search,
        type: 1,
      }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    editSave(data, uuid) {
      editLive(data, uuid).then((res) => {
        console.log(res);
        if (res) {
          if (this.ruleForm.uuid) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("新增成功");
          }
          this.$router.go(-1);
        }
      });
    },
    addSave(data) {
      addLive(data).then((res) => {
        console.log(res);
        if (res) {
          if (this.ruleForm.uuid) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("新增成功");
          }
          this.$router.go(-1);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            // cate_uuid: this.ruleForm.cate_uuid,
            // start_time: this.ruleForm.dates[0],
            // end_time: this.ruleForm.dates[1],
            is_charge: this.ruleForm.price ? 1 : 2,
          };
          if (this.ruleForm.uuid) {
            this.editSave(data, this.ruleForm.uuid);
          } else {
            this.addSave(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.option {
  display: flex;

  & > span {
    width: 50%;
  }
}
</style>
